var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"fileSelector",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel","focusable":"false"},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }